<template>
  <v-layout class="text-no-wrap flex-grow-0 m-auto single-checkbox" row>
    <span class="v-input--selection-controls my-0 pa-0 mr-2 align-center d-inline-flex font-weight-medium">
      {{ filter.label || $t(filter.key) }}:
    </span>
    <div class="options">
      <v-checkbox
        v-for="(option, index) in filter.options"
        :key="index"
        v-model="model"
        :label="$t(option)"
        :value="option"
        class="text-no-wrap my-0 pa-0 align-center"
        dense
        hide-details
        multiple
      />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'FilterControlSingleCheckbox',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', Object.assign({}, this.filter, { value }));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

$margin-between-checkbox-and-label: 5px;

.single-checkbox {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    --single-checkbox-font-size: 0.875em;
    --single-checkbox-checkbox-size: 22px;
  }
  @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
    --options-width: 100%;
    --single-checkbox-font-size: 0.9rem;
    --single-checkbox-checkbox-size: 24px;
  }

  ::v-deep .v-label,
  ::v-deep .v-input--selection-controls {
    font-size: var(--single-checkbox-font-size) !important;
  }

  ::v-deep .v-input--selection-controls__input {
    width: var(--single-checkbox-checkbox-size);
    height: var(--single-checkbox-checkbox-size);
    margin-right: $margin-between-checkbox-and-label;
  }
}

.options {
  display: flex;
  flex-flow: row wrap;
  width: var(--options-width);

  > * {
    margin-right: 20px;
  }
}
</style>
